// extracted by mini-css-extract-plugin
export default {"formGroup":"components_formGroup__jKL-y","formLabel":"components_formLabel__y+unr"};